 export const getUserRole = (() => {
        try {
            return JSON.parse(localStorage.getItem('adminUser'));
        } catch (e) {
            return {};
        }
    });
  